import videojs from 'video.js';

// Modals of the community voting cards: a bigger video and the full description.
const pauseVideos = function (root) {
    root.querySelectorAll('video').forEach(function (video) {
        video.pause();
    });
};

const showPreview = function (dialog) {
    const element = dialog.querySelector('.video-js');
    const player = element ? videojs.getPlayer(element.id) : null;
    if (!player || player.preload() !== 'none') return;

    player.preload('metadata');
    player.load();
};

document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
        const dialog = document.getElementById(opener.dataset.dialogOpen);
        if (!dialog) return;

        // Only one video plays at a time: the small one stops for the big one.
        pauseVideos(document);
        showPreview(dialog);
        dialog.showModal();
        return;
    }

    const dialog = event.target.closest('.community-voting-dialog');
    if (!dialog) return;

    // A click on the backdrop lands on the dialog itself, outside its container.
    if (event.target.closest('[data-dialog-close]') || event.target === dialog) {
        dialog.close();
    }
});

// Also covers closing with Escape.
document.querySelectorAll('.community-voting-dialog').forEach(function (dialog) {
    dialog.addEventListener('close', function () {
        pauseVideos(dialog);
    });
});
